import { window } from "global";
import React, { useState, useEffect } from "react";
// import { usePermissions } from "hooks/general-hooks";

const AdComponent = (props) => {
  // const [permissions] = usePermissions();
  // const [ad, setAd] = useState(null);
  const {
    slotId,
    // shouldChangeForRoute = () => {},
    // backupAd
  } = props;

  return <div id={slotId}></div>;
};

export default AdComponent;
